'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Veranstaltung = require('../entity').Veranstaltung;

module.exports = function (connection) {
  return {
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byNameLike', 'name')(name, additionalParams);
    },
    byRelevantFuerWeitereEquals: function byRelevantFuerWeitereEquals(relevantfuerweitere, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byRelevantFuerWeitereEquals', 'relevantfuerweitere')(relevantfuerweitere, additionalParams);
    },
    byVeranstalterEquals: function byVeranstalterEquals(veranstalter, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byVeranstalterEquals', 'veranstalter')(veranstalter, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byVeranstaltungsTypEquals: function byVeranstaltungsTypEquals(veranstaltungstyp, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byVeranstaltungsTypEquals', 'veranstaltungstyp')(veranstaltungstyp, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byNameEquals', 'name')(name, additionalParams);
    },
    byVeranstaltungsTypLike: function byVeranstaltungsTypLike(veranstaltungstyp, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byVeranstaltungsTypLike', 'veranstaltungstyp')(veranstaltungstyp, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'findOne', 'projection')(projection, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'findAll', 'page')(page, additionalParams);
    },
    byWeitereOrganisationseinheitenEquals: function byWeitereOrganisationseinheitenEquals(weitereorganisationseinheiten, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'byWeitereOrganisationseinheitenEquals', 'weitereorganisationseinheiten')(weitereorganisationseinheiten, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Veranstaltung, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Veranstaltung, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('veranstaltung')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/veranstaltung.js
// module id = Vy7B
// module chunks = 0